module.exports = __webpack_public_path__ + "img/prize.svg";